<template>
    <div>
        <div id="hello-hello">

            <el-tooltip content="只保存最近一个月的记录" placement="top" effect="light">
                <p style="display:inline;float: left;line-height: 22px;"><b>-巡检记录列表</b></p>
            </el-tooltip>

            <el-date-picker v-model="timeFrameValue" type="datetimerange" :picker-options="pickerOptions"
                @change="monthChange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
            </el-date-picker>

            <el-select v-model="statusValue" slot="prepend" placeholder="请选择" @change="selectPatorlStatus"
                style="width:110px">
                <el-option label="异常" value="0"></el-option>
                <el-option label="正常" value="1"></el-option>

                <el-option label="全部" value="-1"></el-option>
            </el-select>

            <el-select v-model="patrolPointId" placeholder="请选择巡检点" style="width:220px" @change="monthChange">
                <el-option v-for="item in patrolPointList" :key="item.value" :label="item.patrolPointName"
                    :value="item.id">
                </el-option>
            </el-select>

            <el-select v-model="maker" placeholder="请选择巡检人" style="width:220px" @change="monthChange">
                <el-option v-for="item in empList" :key="item.value" :label="item.employeeName" :value="item.userId">
                </el-option>
            </el-select>

            <el-button type="primary" @click="searchClick">查询</el-button>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-button round @click="exportExcel">导出</el-button>
                <span>-</span>
            </p>
        </div>

        <el-table :data="patrolRecordList" style="width: 100%" @select="selectClick" @row-click="rowClick"
            ref="patrolPointTable" highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="maker" label="巡检人" min-width="10%">
            </el-table-column>
            <el-table-column prop="createdTime" label="巡检时间" min-width="15%">
            </el-table-column>

            <el-table-column prop="patrolPointCode" label="巡检点编号" min-width="20%">
            </el-table-column>

            <el-table-column prop="patrolPointName" label="巡检点名称" min-width="20%">
            </el-table-column>

            <el-table-column prop="status" label="巡检结果" min-width="10%">
            </el-table-column>
            <el-table-column prop="remark" label="巡检说明" min-width="25%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="180">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        查看
                    </el-button>

                    <el-button @click="adviceClick(scope.row)" type="danger" round size="small"
                        v-if="scope.row.status != '正常'">
                        通知书
                    </el-button>

                    <sup class="radio-sup" v-if="scope.row.needDeal == 0 ? false : true">{{ scope.row.needDeal }}</sup>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[8, 12, 16, 20]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-drawer title="巡检详情" :visible.sync="drawerVisible" size="40%" style="text-align: left;">
            <div style="padding: 0 10px;">
                <el-descriptions>
                    <el-descriptions-item label="巡检点名称">{{ drawer.patrolPointName }}</el-descriptions-item>
                    <el-descriptions-item label="巡检人">{{ drawer.maker }}</el-descriptions-item>
                    <el-descriptions-item label="巡检时间">{{ drawer.createdTime }}</el-descriptions-item>

                    <el-descriptions-item label="巡检说明">{{ drawer.remark }}</el-descriptions-item>
                    <el-descriptions-item label=""></el-descriptions-item>
                    <el-descriptions-item label=""></el-descriptions-item>

                    <el-descriptions-item label="上传照片">
                        <img v-for="item in drawer.imgUrlList" :key="item" :src="'https://' + imagePath + item"
                            class="avatar">
                    </el-descriptions-item>
                </el-descriptions>
            </div>

            <div
                style="background-color: #f5f7fa;color:green;font-size: 14px;text-align:left;padding: 15px 0 15px 10px;">
                巡检项目
            </div>

            <div v-for="item in inspectionItemList" :key="item.id" style="display:flex">
                <p style="text-align: left;width:80%;margin-left: 10px;">{{ item.inspectionName }}</p>

                <div style="display:inline-block;line-height: 40px;margin: 5px 0;font-weight: bold;color: green;">
                    {{ item.status == 1 ? '正常' : '异常' }}
                </div>
            </div>

            <div style="margin-top: 10px;padding-left: 10px;">
                <span style="color: green;">●</span>
                巡检结果 <el-tag type="success">{{ drawer.status }}</el-tag>
            </div>
        </el-drawer>

        <el-dialog title="通知书" :visible.sync="adviceDlg" width="60%">
            <el-form :inline="true" :rules="rules" ref="ruleForm">

                <el-row>
                    <el-col :span="8">
                        <el-form-item label="客户" required :label-width="formLabelWidth">
                            <el-input v-model="customerAbbrev" autocomplete="off" style="width:220px"
                                disabled></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="产品编号" required :label-width="formLabelWidth">
                            <el-input v-model="productCode" autocomplete="off" style="width:220px" disabled></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="产品名称" required :label-width="formLabelWidth" prop="customerAbbrev">
                            <el-input v-model="productName" autocomplete="off" style="width:220px" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div style="width:350px;display: inline-block;"></div>

                <el-row>
                    <el-col :span="16">
                        <el-form-item label="异常描述" :label-width="formLabelWidth">
                            <el-input v-model="remark" autocomplete="off" type="textarea" style="width:570px"
                                disabled></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="确认" required :label-width="formLabelWidth">
                            <el-input v-model="remarkMaker" autocomplete="off" style="width:220px" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="16">
                        <el-form-item label="判定结果" :label-width="formLabelWidth">
                            <el-input v-model="confirmResult" autocomplete="off" type="textarea" style="width:570px"
                                :disabled="resultD == null ? false : true"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="确认" required :label-width="formLabelWidth">
                            <el-input v-model="resultMaker" autocomplete="off" style="width:220px" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="16">
                        <el-form-item label="产生原因" :label-width="formLabelWidth">
                            <el-input v-model="reason" autocomplete="off" type="textarea" style="width:570px"
                                :disabled="reasonD == null ? false : true"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="确认" required :label-width="formLabelWidth">
                            <el-input v-model="reasonMaker" autocomplete="off" style="width:220px" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="16">
                        <el-form-item label="改善对策（生产科）" :label-width="formLabelWidth">
                            <el-input v-model="productCure" autocomplete="off" type="textarea"
                                style="width:570px"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="确认" required :label-width="formLabelWidth">
                            <el-input v-model="productMaker" autocomplete="off" style="width:220px" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="16">
                        <el-form-item label="改善对策（工程科）" :label-width="formLabelWidth">
                            <el-input v-model="engineCure" autocomplete="off" type="textarea"
                                style="width:570px"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="确认" required :label-width="formLabelWidth">
                            <el-input v-model="engineMaker" autocomplete="off" style="width:220px" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="16">
                        <el-form-item label="改善对策（质量科）" :label-width="formLabelWidth">
                            <el-input v-model="qualityCure" autocomplete="off" type="textarea"
                                style="width:570px"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="确认" required :label-width="formLabelWidth">
                            <el-input v-model="qualityMaker" autocomplete="off" style="width:220px" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="16">
                        <el-form-item label="品质跟踪" :label-width="formLabelWidth">
                            <el-input v-model="track" autocomplete="off" type="textarea" style="width:570px"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="确认" required :label-width="formLabelWidth">
                            <el-input v-model="trackMaker" autocomplete="off" style="width:220px" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="16">
                        <el-form-item label="最终确认" :label-width="formLabelWidth">
                            <el-input v-model="lastAssess" autocomplete="off" type="textarea"
                                style="width:570px"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="确认" required :label-width="formLabelWidth">
                            <el-input v-model="assessMaker" autocomplete="off" style="width:220px" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="adviceDlg = false">取 消</el-button>
                <el-button type="primary" @click="$event => saveAdvice('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "PatrolRecord",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),
            imagePath: this.getImagePath(),

            timeFrameValue: '',
            startTime: null,
            endTime: null,

            statusSearchVal: 0,
            patrolPointList: [],
            patrolPointId: '',
            empList: [],
            maker: '',

            patrolRecordList: [],

            drawerVisible: false,
            statusSearch: 0,

            drawer: {
                id: '',
                imgUrlList: [],
                imgFile: null,
                patrolPointCode: '',
                patrolPointName: '',

                maker: '',
                createdTime: '',

                remark: '',
                status: ''
            },

            adviceDlg: false,
            formLabelWidth: '120px',

            customerAbbrev: '',
            productCode: '',
            productName: '',
            remarkMaker: '',

            confirmResult: '',
            resultMaker: '',
            reason: '',
            reasonMaker: '',

            productCure: '',
            productMaker: '',
            engineCure: '',
            engineMaker: '',
            qualityCure: '',
            qualityMaker: '',
            track: '',
            trackMaker: '',
            lastAssess: '',
            assessMaker: '',

            adviceId: '',
            needDeal: 0,
            orderCode: '',

            form: new FormData(),

            resultD: '',
            reasonD: '',
            productD: '',
            engineD: '',
            qualityD: '',
            trackD: '',
            lastAssessD: '',

            resultF: 0,
            reasonF: 0,
            productF: 0,
            engineF: 0,
            qualityF: 0,
            trackF: 0,
            lastAssessF: 0,

            selectedEquipRow: {},

            equipmentId: '',
            equipmentCode: '',
            processId: '',

            productProcessThree: '',
            processQueueThree: null,

            inspectionPicOne: '',
            remark: '',
            processInspection: {},

            inspectionItemList: [],

            pageIndex: 0,
            pageNum: 8,
            total: 0,
            pageCount: 0,

            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            }
        }
    },
    watch: {
        confirmResult(val) {

            if (val != null && val != '' && !this.resultD) {

                this.resultF = 1
            } else {
                this.resultF = 0
            }

        },
        reason(val) {

            if (val != null && val != '' && !this.reasonD) {

                this.reasonF = 1
            } else {
                this.reasonF = 0
            }
        },
        productCure(val) {
            if (val != null && val != '' && !this.productD) {

                this.productF = 1
            } else {
                this.productF = 0
            }
        },
        engineCure(val) {

            if (val != null && val != '' && !this.engineD) {

                this.engineF = 1
            } else {
                this.engineF = 0
            }
        },
        qualityCure(val) {

            if (val != null && val != '' && !this.qualityD) {

                this.qualityF = 1
            } else {
                this.qualityF = 0
            }
        },
        track(val) {

            if (val != null && val != '' && !this.trackD) {

                this.trackF = 1
            } else {
                this.trackF = 0
            }
        },
        lastAssess(val) {

            if (val != null && val != '' && !this.lastAssessD) {

                this.lastAssessF = 1
            } else {
                this.lastAssessF = 0
            }
        }
    },
    methods: {
        selectClick(selection, row) {
            this.rowClick(row)
        },
        rowClick(row) {
            
            this.$refs.patrolPointTable.clearSelection()
            this.$refs.patrolPointTable.toggleRowSelection(row)
        },
        getAllPatrolPoint() {

            this.$axios({
                method: "post",
                url: "/shiro/patrol/point/getAll",
                data: {
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.patrolPointList = data.data
            })
        },
        getAllEmp() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll",
                data: {
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.empList = data.data
            })
        },
        selectPatorlStatus(value) {

            this.statusSearchVal = parseInt(value)

            this.patrolRecordList = []
        },
        monthChange() {

            this.startTime = this.timeFrameValue[0]
            this.endTime = this.timeFrameValue[1]
        },
        searchClick() {
            this.pageIndex=0

            this.getAllPatrolRecord()
        },
        getAllPatrolRecord() { 

            this.$axios({
                method: "post",
                url: "/shiro/patrol/record/getAll",
                data: {
                    startTime: this.startTime,
                    endTime: this.endTime,
                    status: this.statusSearchVal,
                    maker: this.maker,
                    patrolPointId: this.patrolPointId,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.patrolRecordList = data.data
                this.total = this.patrolRecordList[0].total

                for (let i in this.patrolRecordList) {
                    this.patrolRecordList[i].createdTime = this.$moment(this.patrolRecordList[i].createdTime).format("YYYY-MM-DD HH:mm")

                    if (this.patrolRecordList[i].status == 0) {
                        this.patrolRecordList[i].status = '异常'
                    } else {
                        this.patrolRecordList[i].status = '正常'
                    }
                }

            })
        },
        exportExcel() {
            this.$axios({
                method: "post",
                url: "/shiro/patrol/record/excel",
                data: {
                    status: this.statusSearchVal,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    maker: this.maker,
                    patrolPointId: this.patrolPointId,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "巡检统计.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        getInspectionItem(val) {

            this.$axios({
                method: "post",
                url: "/shiro/inspection/item/getAll",
                data: {
                    orderInspectionId: val,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.inspectionItemList = data.data
            })
        },
        handleClick(row) {

            this.drawer.id = row.id

            this.drawer.patrolPointName = row.patrolPointName

            this.drawer.maker = row.maker
            this.drawer.createdTime = row.createdTime

            this.drawer.remark = row.remark
            this.drawer.imgUrlList = row.imgUrlList
            this.drawer.status = row.status

            this.getInspectionItem(row.id)

            this.drawerVisible = true
        },
        saveAdvice() {
            var nd = this.needDeal - this.resultF - this.reasonF - this.productF - this.engineF - this.qualityF - this.trackF - this.lastAssessF

            this.form.append('id', this.adviceId)
            this.form.append('needDeal', nd)
            this.form.append('companyId', this.companyId)

            if (this.resultF == 1) {

                this.form.append('confirmResult', this.confirmResult)
                this.form.append('resultMaker', this.userId)
            } else {

                this.form.append('confirmResult', '')
            }

            if (this.reasonF == 1) {

                this.form.append('reason', this.reason)
                this.form.append('reasonMaker', this.userId)
            } else {

                this.form.append('reason', '')
            }

            if (this.productF == 1) {

                this.form.append('productCure', this.productCure)
                this.form.append('productMaker', this.userId)
            } else {

                this.form.append('productCure', '')
            }

            if (this.engineF == 1) {

                this.form.append('engineCure', this.engineCure)
                this.form.append('engineMaker', this.userId)
            } else {

                this.form.append('engineCure', '')
            }

            if (this.qualityF == 1) {

                this.form.append('qualityCure', this.qualityCure)
                this.form.append('qualityMaker', this.userId)
            } else {

                this.form.append('qualityCure', '')
            }

            if (this.trackF == 1) {

                this.form.append('track', this.track)
                this.form.append('trackMaker', this.userId)
            } else {

                this.form.append('track', '')
            }

            if (this.lastAssessF == 1) {

                this.form.append('lastAssess', this.lastAssess)
                this.form.append('assessMaker', this.userId)
            } else {

                this.form.append('lastAssess', '')
            }

            this.$axios({
                method: "post",
                url: "/shiro/abnormal/advice/modify",
                data: this.form,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg
                })

                this.getAllPatrolRecord()

                this.adviceDlg = false
            })
        },
        adviceClick(row) {

            this.form = new FormData()
            this.resultF = 0
            this.reasonF = 0
            this.productF = 0
            this.engineF = 0
            this.qualityF = 0
            this.trackF = 0
            this.lastAssessF = 0

            this.$axios({
                method: "post",
                url: "/shiro/abnormal/advice/get",
                data: {
                    patrolRecordId: row.id,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.needDeal = row.needDeal

                this.adviceId = data.data.id

                this.customerAbbrev = data.data.customerAbbrev
                this.productCode = data.data.productCode
                this.productName = data.data.productName
                this.remark = data.data.remark
                this.remarkMaker = data.data.remarkMaker

                this.resultD = this.confirmResult = data.data.confirmResult
                this.resultMaker = data.data.resultMaker
                this.reasonD = this.reason = data.data.reason
                this.reasonMaker = data.data.reasonMaker

                this.productD = this.productCure = data.data.productCure
                this.productMaker = data.data.productMaker
                this.engineD = this.engineCure = data.data.engineCure
                this.engineMaker = data.data.engineMaker

                this.qualityD = this.qualityCure = data.data.qualityCure
                this.qualityMaker = data.data.qualityMaker
                this.trackD = this.track = data.data.track
                this.trackMaker = data.data.trackMaker

                this.lastAssessD = this.lastAssess = data.data.lastAssess
                this.assessMaker = data.data.assessMaker

                this.adviceDlg = true
            })

        },
        pageClick(currentPage) {
            this.patrolRecordList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getAllPatrolRecord()
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAllPatrolRecord()
        },
    },
    mounted() {
        this.setDefaultPath('/patrolRecord')

        const now = new Date()

        // 获取昨天的日期并设置为晚上8点
        const lastNight = new Date()
        lastNight.setDate(now.getDate() - 1)
        lastNight.setHours(20, 0, 0, 0)

        this.startTime = lastNight
        this.endTime = new Date()

        this.getAllEmp()

        this.getAllPatrolPoint()

        this.getAllPatrolRecord()
    }
}
</script>

<style>
.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-descriptions-item__content {
    color: green;
    font-weight: bold;
}

.radio-sup {
    border-radius: 8px;
    color: #fff;
    display: inline-block;
    font-size: 13px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
    background-color: red;
    position: absolute;
    top: 10px;
    right: 10%;
}
</style>